
<template>
  <div
    :class="[
      wrapperClass,
      { 'has-error has-danger': validator && validator.$error && !wrapped },
    ]"
  >
    <div
      v-if="wrapped"
      :id="'select-wrapper-' + id"
      :class="[
        { 'has-error has-danger': (validator && validator.$error) || errors },
        selectWrapperClass,
      ]"
    />
    <slot name="icon" />
    <div
      v-if="!multiple && !remote"
      :class="[
        'container__form rail-select',
        { validateInput: validator ? !validator.$error : field },
        {
          labelMarginForPlaceHolder:
            label && (optionValue ? !field : Object.keys(field).length < 1),
        },
      ]"
    >
      <label
        v-if="label"
        :for="id"
        :class="[labelClass]"
        class="container__label"
      >
        {{ label }}<span v-if="validator && validator.$params.required">*</span>
        <span v-if="helpText"
              :title="helpText"
              data-toggle="tooltip">?</span>
      </label>

      <select
        :id="id"
        v-model="field"
        :class="[selectClass]"
        :disabled="disabled"
        class="container__input selectStyle"
        @change="!validator || validator.$touch()"
        @focus="onFocus"
      >
        <option v-if="withDefault"
                v-once
                :value="null" />
        <option
          v-for="(option, index) in options"
          v-show="option.visible != false"
          :key="option[optionLabel] + index"
          :value="optionValue ? option[optionValue] : option"
        >
          {{ option[optionLabel] }}
        </option>
      </select>
    </div>
    <select
      v-else-if="!multiple && remote"
      :id="id"
      :value="field"
      :class="[selectClass]"
      :disabled="disabled"
      @change="!validator || validator.$touch()"
    >
      <option v-if="withDefault"
              v-once
              value="">
        {{ defaultText }}
      </option>
      <option
        v-for="(option, index) in remoteOptions"
        :key="option[remoteOptionsLabel] + index"
        :value="option"
      >
        {{ option[remoteOptionsLabel] }}
      </option>
    </select>
    <select v-else
            :id="id"
            :class="[selectClass]" />
    <div
      :id="'select-help-block-' + id"
      class="help-block form-text form-control-feedback"
    >
      <template v-for="(error, index) in errors">
        <strong :key="index"> {{ error }} </strong>
      </template>
      <!-- <strong v-if="validator && validator.$params.required && validator.$error && !validator.required">you have to select one of {{ label.toLowerCase() }}!</strong> -->
      <strong
        v-if="
          validator &&
            validator.$params.minLength &&
            validator.$error &&
            validator.minLength
        "
      >min length should not be less then
        {{ validator.$params.minLength.min }} characters!</strong
        >
    </div>
  </div>
</template>

<script>
export default {
	name: 't-select',
	props: {
		label: {
			type: String,
			default: ''
		},
		labelClass: {
			type: String,
			default: 'col-form-label col-sm-4'
		},
		selectClass: {
			type: String,
			default: 'form-control'
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		selectWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		options: {
			type: Array,
			default: () => {
				return []
			}
		},
		optionLabel: {
			type: String,
			default: null
		},
		helpText: {
			type: String,
			default: null
		},
		optionValue: {
			type: String,
			default: ''
		},
		withDefault: {
			type: Boolean,
			default: false
		},
		defaultText: {
			type: String,
			default: ''
		},
		value: {
			type: [Number, String, Array, Object, Boolean],
			default: 0
		},
		multiple: {
			type: Boolean,
			default: false
		},
		simple: {
			type: Boolean,
			default: false
		},
		wrapped: {
			type: Boolean,
			default: false
		},
		filter: {
			type: Boolean,
			default: false
		},
		validator: {
			type: Object,
			default: null
		},
		remote: {
			type: String,
			default: null
		},
		templateResult: {
			type: Function,
			default: null
		},
		templateSelection: {
			type: Function,
			default: null
		},
		processResults: {
			type: Function,
			default: null
		},
		processParams: {
			type: Function,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => {
				return null
			}
		}
	},
	data () {
		return {
			remoteOptions: [],
			remoteOptionsLabel: ''
		}
	},
	computed: {
		field: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('change', value)
				this.$emit('input', value)
			}
		},
		id () {
			return Math.random().toString().replace('0.', '')
		}
	},
	watch: {
		options: {
			handler () {
				if (this.multiple && !this.simple) this.initMultipleSelect()
			},
			deep: true
		},
		disabled (newVal) {
			let select = document.getElementById(this.id)
			jQuery(select).prop('disabled', newVal)
		}
	},
	mounted () {
		if (this.wrapped) {
			let wrapper = document.getElementById(`select-wrapper-${this.id}`)
			let select = document.getElementById(this.id)
			let helpBlock = document.getElementById(`select-help-block-${this.id}`)
			wrapper.appendChild(select)
			wrapper.appendChild(helpBlock)
		}
		if (this.options && this.multiple && !this.remote && !this.simple) { this.initMultipleSelect() }
		if (this.remote) this.initRemoteSelect()
	},
	destroyed: function () {
		if (this.multiple && !this.simple) {
		}
	},
	methods: {
		onFocus () {
			this.$emit('focus')
		},
		initMultipleSelect () {
		},
		initRemoteSelect () {
		},
		reset () {
			if (this.options && this.multiple && !this.remote && !this.simple) {
				let select = document.getElementById(this.id)
				jQuery(select).val([]).trigger('change')
				return
			}
			this.field = null
		}
	}
}
</script>
<style scoped>
.has-danger .container__form label {
  /* top: -14px; */
  left: -10px;
  /* height: 10%; */
  /* padding:0!important; */
  color: red;
  border: none;
  background: none;
}

.container__label {
  position: absolute;
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  width: auto;
  top: -14px;
  left: 0px;
  height: 10%;
  padding: 0.8em 0.5em;
  color: #6a6d71 !important;
  background: noneimportant;
  border: none !important;
}
.container__form {
  position: relative;
}
.container__input {
  width: 100%;
  height: 40px;
  padding: 1em;
  padding-left: 0 !important;
  /* border: 1px solid #2298ef75; */
  background-color: #fff !important;
  font-weight: normal;
}

.container__input.selectStyle {
  padding-top: 0;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/select/index.vue